import React, { useEffect, useState } from "react";
import styles from "../ShareData/share.module.css";
import { Button, TextField } from "@mui/material";
import { createKey, getKey } from "../../services/key.service";
import { toast } from "react-toastify";

function Key() {
  const [keys, setKeys] = useState({
    client_id: "",
    client_secret: "",
    grant_type: "",
    scope: "",
    id: "",
  });
  const [isEdit, setIsEdit] = useState(false);

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setKeys({ ...keys, [name]: value });
    setIsEdit(true);
  };
  const getkeyService = () => {
    getKey().then((res) => {
      if (res?.data) {
        setKeys({ ...res?.data?.result, id: res?.data?.result?._id });
      }
    });
  };

  useEffect(() => {
    getkeyService();
  }, []);

  const handleSubmit = () => {
    createKey(keys).then((res) => {
      toast.success(res?.data?.message);
      getkeyService();
    });
  };

  return (
    <div>
      <h1 className={styles.head}>Set Private Keys</h1>
      <div className="flex flex-col items-center p-4 space-y-4">
        <TextField
          label="Client ID"
          variant="outlined"
          className="w-full"
          name="client_id"
          onChange={handleChange}
          value={keys.client_id}
        />
        <TextField
          label="Client Secret"
          variant="outlined"
          className="w-full"
          name="client_secret"
          onChange={handleChange}
          value={keys.client_secret}
        />
        <TextField
          label="Grant Type"
          variant="outlined"
          className="w-full"
          name="grant_type"
          onChange={handleChange}
          value={keys.grant_type}
        />
        <TextField
          label="Scope"
          variant="outlined"
          className="w-full"
          name="scope"
          onChange={handleChange}
          value={keys.scope}
        />
        <Button
          variant="contained"
          color="primary"
          name="scope"
          onClick={handleSubmit}
          disabled={!isEdit}
        >
          Submit
        </Button>
      </div>
    </div>
  );
}

export default Key;
